import PropTypes from 'prop-types';
import React from 'react';
import InputEditor from './InputEditor';
const PriceInput = ({ props } = {}) => {
    const priceInput = ({ value, onValue }) => {
        const onKeyUp = ({ key, target: { value } }) => {
            if (key === 'Enter') {
                onValue(parseValue(value));
            }
        };
        const onBlur = ({ target: { value } }) => {
            onValue(parseValue(value));
        };
        const parseValue = v => (value === parseFloat(value) ? parseFloat(v) : v);
        return (React.createElement(InputEditor, Object.assign({ initialValue: value, onKeyUp: onKeyUp, onBlur: onBlur, onValue: onBlur }, props)));
    };
    priceInput.propTypes = {
        value: PropTypes.any,
        onValue: PropTypes.func,
    };
    return priceInput;
};
export default PriceInput;
